import { useId } from 'react'
import './Checkbox.css'

export type CheckboxProps = {
  label: string
  checked: boolean
  onChange: (checked: boolean) => void
}

export function Checkbox({ label, checked, onChange }: CheckboxProps) {
  const id = useId()
  return (
    <label className="ui-checkbox" htmlFor={id}>
      <input
        id={id}
        type="checkbox"
        className="ui-checkbox__input"
        checked={checked}
        onChange={(event) => onChange(event.target.checked)}
      />
      <span className="ui-checkbox__box" aria-hidden="true">
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#ffffff" strokeWidth={3} strokeLinecap="round" strokeLinejoin="round">
          <path d="M4.5 12.5l5 5L19.5 7" />
        </svg>
      </span>
      <span className="ui-checkbox__label">{label}</span>
    </label>
  )
}
